module  Client.ContractPage.PurchaseOrders.Basic

open Client
open Fable.React
open Fable.React.Props
open Feliz
open Feliz.Bulma
open Fulma
open PortalLibs.Client.Util
open Model
open Fable.FontAwesome
open PortalLibs.Shared
open ContractPageModel

let View addRequesting (contract: Contract) (purchaseOrders: PurchaseOrder list option) dispatch =
  Card.card [ Props [
                Style [
                  MarginRight "15px"
                  MarginTop "10px"
                  BorderRadius ".5rem"
                ]
              ] ] [
    yield
      Card.header [] [
        Card.Header.title [ Card.Header.Title.Props [
                              Style [
                                PaddingTop "5px"
                                PaddingBottom "5px"
                                Display DisplayOptions.Flex
                                FlexWrap "wrap"
                                AlignItems AlignItemsOptions.Center
                              ]
                            ] ] [
          yield
            span [ Style [ Width "380px" ] ] [
              str "Purchase Orders"
            ]
          match purchaseOrders with
          | None ->
            yield
              Icon.icon [ Icon.Size ISize.IsMedium ] [
                Fa.i [ Fa.Solid.Spinner
                       Fa.Pulse
                       (Fa.Size Fa.Fa2x) ] []
              ]
          | Some _ -> ()
        ]
        if addRequesting then
          Bulma.cardHeaderIcon.a [
          prop.style [
            style.paddingTop (length.px 5)
            style.paddingBottom (length.px 5)
          ]
          prop.children [
            Bulma.button.button [
              prop.onClick (fun _ ->
                contract.Id
                |> Some
                |> RequestPurchaseOrderContractId
                |> dispatch)
              prop.children [
                Bulma.icon [
                  prop.style [ style.color.green ]
                  prop.children [
                    Fa.i [ Fa.Solid.Plus ] []
                  ]
                ] 
              ]
            ]
          ]
        ]
      ]
    match purchaseOrders with
    | None -> ()
    | Some orders ->
      match orders with
      | [] -> ()
      | _ ->
        yield
          Card.content [ Props [ Style [ PaddingRight "0" ] ] ] [
            Content.content
              [ Content.CustomClass "purchase-orders-cont"
                Content.Props [
                  Style [
                    Display DisplayOptions.Flex
                    FlexWrap "wrap"
                    AlignItems AlignItemsOptions.Center
                  ]
                ] ]
              (orders
               |> List.map
                    (fun order ->
                      div [ Style [
                              Display DisplayOptions.Flex
                              FlexWrap "wrap"
                              AlignItems AlignItemsOptions.Center
                              JustifyContent "space-between"
                              Width "100%"
                              PaddingRight "25px"
                            ] ] [
                        span [] [
                          order.VendorName |> str
                        ]
                        span [
                             ] [
                          order.TotalCosts.TotalCost
                          |> float
                          |> DisplayNumber.AsCurrency.stdStr
                        ]
                      ]))

          ]
  ]